import client from '../client'

export const getCalculatorPropertiesKey = `${process.env.NEXT_PUBLIC_PURCHASE_DOMAIN}/api/Calculations/GetProperties`

export async function getCalculatorProperties() {
  return client(getCalculatorPropertiesKey)
}
